"use client";

import { type JSX } from "react";
import { ColumnSplitterBase } from "./ColumnSplitterBase";
import { SplitterProps } from "components/sxa/column-splitter/column-splitter.props";

export const Default = (props: SplitterProps): JSX.Element => {
  console.log("---->[FourColumnSplitter] Component", props.params);

  return (
    <ColumnSplitterBase
      {...props}
      config={{ variantName: "four", defaultEnabledPlaceholders: "1,2,3,4" }}
    />
  );
};